export default "__VITE_ASSET__D_4QMn1Y__"